import PropTypes from 'prop-types';
import React from 'react';
import Moment from 'react-moment';
import 'moment-timezone';
import 'moment/locale/es';
import 'moment/locale/pt';

var MomentDate = function MomentDate(_ref) {
  var format = _ref.format,
      locale = _ref.locale,
      date = _ref.date,
      timezone = _ref.timezone;
  return React.createElement(Moment, {
    format: format,
    locale: locale,
    tz: timezone,
    notranslate: 'true'
  }, date);
};

MomentDate.propTypes = {
  format: PropTypes.string.isRequired,
  locale: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  timezone: PropTypes.string
};
MomentDate.defaultProps = {
  locale: 'en'
};
export default MomentDate;